import { axiosInstance } from './common';

export const getUserDetails = () => axiosInstance.get(`/user/details`).then((response) => response.data);

export const getOrganization = (organizationId) => axiosInstance.get(`/organization/get/${organizationId}`).then((response) => response.data);
export const createOrganization = (name, description) => axiosInstance.post(`/organization/create`, { name, description }).then((response) => response.data);
export const updateSettings = (settings) => axiosInstance.post(`/user/updateSettings`, settings).then((response) => response.data);

export const addUsersByEmailToOrganization = (request) => axiosInstance.post(`/organization/addUsersByEmails`, request).then((response) => response.data);

export const leaveOrganization = () => axiosInstance.post(`/organization/leave`).then((response) => response.data);

export const removeUserFromOrganization = (userId) => axiosInstance.delete(`/organization/removeUser/${userId}`).then((response) => response.data);